module.exports = __webpack_public_path__ + "img/black-watch.cad494c2.jpg";